import React from 'react';
import { Checkbox } from 'react-bootstrap';
import { safeMutate } from '../../../../utils/GeneralUtils';
import { getUId, propagateData } from '../utils';
/*

props = {
  data: {
    useThemeColor: < true || false >,
    value: <>,
    label: <>,
    checked: < true || false >,
    disabled: < true || false >,
    className: <>
  },
  uId: <uniqueIdentifier>,
  onChange: <handler>
}

*/

const ChrCheckbox = (props) => {
  const formData = props.data;
  const myUId = getUId(props);

  const onChangeHandler = (event) => {
    const newFormData = safeMutate(formData, draftData => {
      draftData.checked = event.target.checked;
    });
    propagateData(event, myUId, newFormData, props);
  };

  return (
    <>
      { formData.useThemeColor ?
        <div className={ `awesome-bootstrap checkbox-primary checkbox ${formData.className}` } {...props.extraProps} >
          <input
            id={ myUId }
            type='checkbox'
            className={`m-0 position-relative ${formData.inputClass}`}
            checked={ formData.checked || false }
            disabled={ formData.disabled || false }
            onChange={ onChangeHandler }
            aria-label={ formData["aria-label"] || formData.label }
          />
          <label htmlFor={ myUId } className={ formData.labelClass }> {formData.label} </label>
        </div>
        :
        <Checkbox
          value={formData.value}
          checked={formData.checked || false}
          disabled={formData.disabled || false}
          className={formData.className}
          inline={formData.inline}
          name={formData.name}
          onChange={onChangeHandler}
          aria-label={ formData["aria-label"] || formData.label }>
          {formData.label}
          {formData.helpText && <span className="text-muted small">{` ${formData.helpText}`}</span>}
        </Checkbox>
      }
    </>
  );
};

export default ChrCheckbox;